(function () {
  'use strict';

  angular
    .module('admin.users.details.print_escrows', [])
    .controller('PrintEscrowsUserCtrl', PrintEscrowsUserCtrl);

  /** @ngInject */
  function PrintEscrowsUserCtrl($stateParams, UsersService) {
    var vm = this;
    vm.items = [];
    vm.itemsLogs = [];
    vm.perPage = 25;
    vm.prints = [];
    vm.userId = $stateParams.parentId;

    function reloadPaginationEscrow() {
      vm.totalItems = 0;
      vm.oldPage = 0;
      vm.currentPage = 25;
      vm.first = true;
      vm.totalItems = 0;
      vm.pagination = {
        current: 1
      };
    }

    function reloadPaginationLog() {
      vm.totalItems2 = 0;
      vm.oldPage2 = 0;
      vm.currentPage2 = 25;
      vm.first2 = true;
      vm.totalItems2 = 0;
      vm.pagination2 = {
        current: 1
      };
    }

    reloadPaginationEscrow();
    reloadPaginationLog();

    var tab = localStorage.getItem("ambassador_giveaway");
    if (tab !== null) {
      if (tab === "escrow") {
        $("#log").removeClass("active");
        $("#escrow").addClass("active");
        $("#escrowtab").addClass("active");
      } else {
        $("#escrow").removeClass("active");
        $("#log").addClass("active");
        $("#logtab").addClass("active");
      }
    } else {
      $("#escrow").addClass("active");
      $("#escrowtab").addClass("active");
    }

    vm.tabEscrows = function () {
      $("#log").removeClass("active");
      $("#escrow").addClass("active");
      localStorage.setItem("ambassador_giveaway", "escrow");
    };

    vm.tabLogs = function () {
      $("#escrow").removeClass("active");
      $("#log").addClass("active");
      localStorage.setItem("ambassador_giveaway", "logs");
    };

    function loadEscrow(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination.current = 1;
      }
      if (!vm.first) {
        vm.currentPage = pageNumber * 25;
        vm.oldPage = vm.currentPage - 25;
      } else {
        vm.first = false;
      }

      UsersService.listPrintEscrows(vm.userId, vm.oldPage, 25).then(function (result) {
        if (vm.totalItems === 0) {
          vm.totalItems = result.ct;
        }

        for (var i = 0; i < result.results.length; i++) {
          result.results[i].check = false;
        }
        vm.items = result.results;
      });
    };

    function loadLogs(pageNumber) {
      if (pageNumber === 1) {
        vm.pagination2.current = 1;
      }
      if (!vm.first2) {
        vm.currentPage2 = pageNumber * 25;
        vm.oldPage2 = vm.currentPage2 - 25;
      } else {
        vm.first2 = false;
      }

      UsersService.listPrintEscrowsTransfer(vm.userId, vm.oldPage, 25).then(function (result) {
        if (vm.totalItems2 === 0) {
          vm.totalItems2 = result.ct;
        }

        for (var i = 0; i < result.results.length; i++) {
          if (result.results[i].k === 1) {
            result.results[i].type = 'Bundle Purchase'
          } else if (result.results[i].k === 2) {
            result.results[i].type = 'Trade'
          } else if (result.results[i].k === 3) {
            result.results[i].type = 'Listing'
          } else if (result.results[i].k === 4) {
            result.results[i].type = 'Ebay Auction'
          } else if (result.results[i].k === 5) {
            result.results[i].type = 'Account Transfer'
          } else if (result.results[i].k === 6) {
            result.results[i].type = 'Print Transfer'
          } else if (result.results[i].k === 7) {
            result.results[i].type = 'Giveaway'
          } else if (result.results[i].k === 8) {
            result.results[i].type = 'Mintable Wallet Association'
          } else {
            result.results[i].type = 'Unknownn'
          }
        }

        vm.itemsLogs = result.results;
      });
    };

    loadEscrow(1);
    loadLogs(1);

    vm.load = function () {
      reloadPaginationEscrow();
      loadEscrow(1);
    };

    vm.loadLog = function () {
      reloadPaginationLog();
      loadLogs(1);
    };

    vm.pageChanged = function (newPage) {
      loadEscrow(newPage);
      $("html, body").animate({ scrollTop: 0 }, 0);
    };

    vm.pageChanged2 = function (newPage) {
      loadLogs(newPage);
      $("html, body").animate({ scrollTop: 0 }, 0);
    };
  }

})();
